import React, { FC } from "react";

import { Progress } from 'antd';

const ProgressBar: FC<any> = ({percent,strokeColor}) => {
    return <Progress percent={percent} strokeColor={strokeColor}/>
}


export default ProgressBar;
